import { makeActionCreator } from '../../util/make_action_creator'

export const SET_ACTIVE = 'SET_ACTIVE'
export const SET_INACTIVE = 'SET_INACTIVE'
export const CLEAR_ALL_TYPING_INDICATORS = 'CLEAR_ALL_TYPING_INDICATORS'

export const setActive = makeActionCreator(
  SET_ACTIVE,
  'modelName',
  'activeLookup',
  'isAFetchAll',
)
export const setInactive = makeActionCreator(
  SET_INACTIVE,
  'modelName',
  'inactiveLookup',
)

export const clearAllTypingIndicators = makeActionCreator(CLEAR_ALL_TYPING_INDICATORS)
